"use client";

import styles from "./Modal.module.scss";
import { useEffect, useRef } from "react";
import type { ModalTypes } from "./Modal.types";

const Modal = ({ isOpen, onClose, children }: ModalTypes) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (ref.current && !ref.current.contains(target)) {
        onClose();
      }
    };

    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };

    if (isOpen) {
      document.body.style.overflow = "hidden";
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className={styles["comp"]}>
      <div
        className={styles["comp__background"]}
        onClick={onClose}
        aria-hidden
      />
      <div className={styles["comp__container"]}>
        <div className={styles["comp__content"]} ref={ref}>
          {children}
        </div>
      </div>
    </div>
  );
};

export { Modal };
